import React from 'react';
export const Offer = () => {
  return <section className="py-6 sm:py-8" data-id="element-132">
      <div className="bg-gradient-to-r from-[#E55A88] to-pink-500 text-white p-5 sm:p-8 rounded-lg" data-id="element-133">
        <h2 className="text-xl sm:text-2xl font-bold mb-4" data-id="element-134">Your Options</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6 mb-5" data-id="element-135">
          <div className="bg-white text-[#E55A88] p-5 sm:p-6 rounded-md" data-id="element-136">
            <h3 className="text-lg sm:text-xl font-bold mb-2" data-id="element-137">
              One-Time Purchase
            </h3>
            <p className="text-xl sm:text-2xl font-bold mb-1" data-id="element-138">$59.99</p>
            <p className="text-gray-600 mb-4 text-sm" data-id="element-139">(plus shipping)</p>
            <a href="https://trymenobloom.com/products/meno-bloom" className="block w-full" data-id="element-140">
              <button className="w-full bg-[#E55A88] hover:bg-pink-600 text-white font-bold py-3 px-4 rounded-md text-sm sm:text-md transition duration-300" data-id="element-141">
                GET MENOBLOOM - ONE TIME $59.99
              </button>
            </a>
          </div>
          <div className="bg-white text-[#E55A88] p-5 sm:p-6 rounded-md border-2 border-yellow-400" data-id="element-142">
            <div className="bg-yellow-400 text-[#E55A88] font-bold text-xs sm:text-sm py-1 px-3 rounded-full inline-block mb-2" data-id="element-143">
              BEST VALUE
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-2" data-id="element-144">
              Subscribe & Save
            </h3>
            <p className="text-xl sm:text-2xl font-bold mb-1" data-id="element-145">$53.99/month</p>
            <p className="text-gray-600 mb-4 text-sm" data-id="element-146">(FREE shipping)</p>
            <a href="https://trymenobloom.com/products/meno-bloom" className="block w-full" data-id="element-147">
              <button className="w-full bg-yellow-400 hover:bg-yellow-500 text-[#E55A88] font-bold py-3 px-4 rounded-md text-sm sm:text-md transition duration-300" data-id="element-148">
                SUBSCRIBE & SAVE $53.99/MONTH
              </button>
            </a>
          </div>
        </div>
        <p className="text-base sm:text-lg mb-4 italic" data-id="element-149">
          Less than $1.80 per day to feel like yourself again
        </p>
        <p className="mb-3 text-sm sm:text-base font-bold" data-id="element-150">
          Subscribe and get:
        </p>
        <ul className="space-y-2 mb-5 text-sm sm:text-base" data-id="element-151">
          <li className="flex items-start" data-id="element-152">
            <span className="text-white mr-2" data-id="element-153">✓</span>
            <span data-id="element-154">FREE shipping (saves $9.95/month)</span>
          </li>
          <li className="flex items-start" data-id="element-155">
            <span className="text-white mr-2" data-id="element-156">✓</span>
            <span data-id="element-157">Never run out</span>
          </li>
          <li className="flex items-start" data-id="element-158">
            <span className="text-white mr-2" data-id="element-159">✓</span>
            <span data-id="element-160">Cancel anytime</span>
          </li>
          <li className="flex items-start" data-id="element-161">
            <span className="text-white mr-2" data-id="element-162">✓</span>
            <span data-id="element-163">FREE Menopause Gut Health Guide</span>
          </li>
          <li className="flex items-start" data-id="element-164">
            <span className="text-white mr-2" data-id="element-165">✓</span>
            <span data-id="element-166">FREE access to private community</span>
          </li>
          <li className="flex items-start" data-id="element-167">
            <span className="text-white mr-2" data-id="element-168">✓</span>
            <span data-id="element-169">FREE monthly expert Q&As</span>
          </li>
        </ul>
        <div className="mb-5" data-id="element-170">
          <h3 className="text-lg sm:text-xl font-bold mb-2" data-id="element-171">
            90-Day "Feel Amazing" Guarantee
          </h3>
          <p className="text-sm sm:text-base" data-id="element-172">
            Try MenoBloom risk-free for 90 days. If you don't feel significantly
            better, return your bottles (even empty) for a full refund.
          </p>
          <p className="mt-2 text-sm sm:text-base" data-id="element-173">No questions asked.</p>
        </div>
      </div>
      <div className="mt-6 sm:mt-8 prose max-w-none text-base" data-id="element-174">
        <h2 className="text-2xl font-bold text-[#E55A88] mb-5" data-id="element-175">
          Don't Wait Another Day
        </h2>
        <p data-id="element-176">
          Every day you wait is another day of night sweats, weight frustration,
          mood swings, and brain fog.
        </p>
        <p data-id="element-177">The women in our community got their lives back. You can too.</p>
        <div className="my-6 sm:my-8 flex flex-col sm:flex-row gap-4 justify-center" data-id="element-178">
          <a href="https://trymenobloom.com/products/meno-bloom" className="block w-full sm:w-auto" data-id="element-179">
            <button className="w-full bg-[#E55A88] hover:bg-pink-600 text-white font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-md text-base sm:text-lg transition duration-300" data-id="element-180">
              GET MENOBLOOM - ONE TIME $59.99
            </button>
          </a>
          <a href="https://trymenobloom.com/products/meno-bloom" className="block w-full sm:w-auto" data-id="element-181">
            <button className="w-full bg-yellow-400 hover:bg-yellow-500 text-[#E55A88] font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-md text-base sm:text-lg transition duration-300" data-id="element-182">
              SUBSCRIBE & SAVE $53.99/MONTH
            </button>
          </a>
        </div>
        <p className="italic text-sm sm:text-base" data-id="element-183">
          P.S. You've tried everything else and been dismissed for too long.
          Isn't it time to try something created FOR women who understand
          exactly what you're going through?
        </p>
        <p className="text-xs text-gray-500 mt-4" data-id="element-184">
          *These statements have not been evaluated by the FDA. This product is
          not intended to diagnose, treat, cure, or prevent any disease.
        </p>
      </div>
    </section>;
};